module.exports = __webpack_public_path__ + "img/UAVsystem1.c2652489.jpg";